export default __webpack_public_path__ + "static/af917c557f4ebf4117eabb49e9b7c9a5.jpg";